module.exports = __webpack_public_path__ + "static/freihofer-7f1be37b6a04cdf46268c5b029b40d5b.png";